import { AvailableTabs } from 'constants/SidebarTabs';
import { NormalizedLoad } from 'types/Load';

import { getCurrentUrl } from './current-url';
import { TMSHost } from './interface';

export class Stark implements TMSHost {
  private getCurrentUrl: () => string;

  constructor(getCurrentUrlFn?: () => string) {
    this.getCurrentUrl = getCurrentUrlFn || getCurrentUrl;
  }

  getFieldMoniker(key: keyof NormalizedLoad): string {
    switch (key) {
      case 'externalTMSID':
        return '';
      case 'freightTrackingID':
        return 'Stark Shipment ID';
      default:
        return '';
    }
  }

  parseFreightTrackingID(): string {
    // Parse shipment ID from URL pattern: https://apps-staging.transfix.io/#/shipment-details/1734986
    // or https://apps.transfix.io/#/shipment-details/1734986
    const url = this.getCurrentUrl();
    const match = url.match(/\/shipment-details\/(\d+)/);
    if (match) {
      return match[1];
    }
    return '';
  }

  // ExternalTMSID = FreightTrackingID for Stark
  parseExternalTMSID(): string {
    return this.parseFreightTrackingID();
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    const url = this.getCurrentUrl();
    return url.includes('/shipment-details/') || url.includes('booking');
  }
}
